import { useEffect, useState } from "react";

const calculateTimeLeft = (futureTime) => {
  const diff = new Date(futureTime) - new Date();

  if (diff <= 0) return null;

  return {
    hours: Math.floor(diff / (1000 * 60 * 60)),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
};

const CountdownTimer = ({ futureTime }) => {
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    if (!futureTime) return;

    const update = () => {
      setTimeLeft(calculateTimeLeft(futureTime));
    };

    update();
    const interval = setInterval(update, 1000);

    return () => clearInterval(interval);
  }, [futureTime]);

  if (!futureTime) {
    return <p>Auto-refill is not scheduled</p>;
  }

  if (!timeLeft) {
    return <p>Auto-refill is running now</p>;
  }

  return (
    <p>
      Next auto-refill in{" "}
      <strong>
        {String(timeLeft.hours).padStart(2, "0")}:
        {String(timeLeft.minutes).padStart(2, "0")}:
        {String(timeLeft.seconds).padStart(2, "0")}
      </strong>
    </p>
  );
};

export default CountdownTimer;
